<template>
    <div class="inner-container">
        <div class="section-subtitle"><i class="icon icon-grid"></i><span>{{ $t("app.links.budget_requests") }}<budget-forms-list :curFormSelect="'/form01-123'"/></span>
            <forms-download-reprt
                :progress="progress"
                :isReportUploading="isReportUploading"
                :form="form"
                :guListLen="guListLen"
                :header="header"
                :isParentGuExist="isParentGuExist"
                :isHeadGu="isHeadGu"
                :isGkkpPaid="true"
                @checkSignatories="checkSignatories"
                @downloadRep="downloadRep"
                @downloadRepPaid="downloadRepPaid"
                @downloadBatchReports="downloadBatchReports"
                @downloadBatchReportsPaid="downloadBatchReportsPaid"
                :hasDeltaRep="true"
                @downloadDeltaRep="downloadDeltaRep"
            ></forms-download-reprt>
        </div>
     <div class="filter-container">
         <div class="left-content">
         </div>
         <div class="right-content">
                <c-budget-forms-data-transfer
                    v-if="!isGkkpMode && !(progress < 100) && variantAttribute"
                    :header="header"
                    :lng="lng"
                    :getDataTransferText="getDataTransferText"
                    :getErrText="getErrText"
                    :makeToast="makeToast"
                    @reloadTable="loadDatas"
                />
             <div class="filter-actions filter-actions-flex">
                    <c-budget-forms-copy-data
                        v-if="!(progress < 100) && variantAttribute && (header.year < header.cur_year + 2)"
                        :budgetForm="isPaidTab ?  budgetFormPaid : budgetForm"
                        :header="header"
                        :isLoad="isLoad"
                        :isPaidTab="isPaidTab"
                        @keyPress="keyPress"
                    />
                    <b-button :style="{ 'minWidth': '110px' }" variant="primary" @click="onEnterCategoryName" v-if="variantAttribute" :disabled="isLoad"><i class="icon icon-plus-circle"></i> {{ getCommonText('add') }}</b-button>
                    <b-button :style="{ 'minWidth': '110px' }" variant="success" @click="prepareForSave" :disabled="isLoad || !variantAttribute">{{ getCommonText('save') }}</b-button>
                </div>
            </div>
        </div>

        <b-tabs 
            active-nav-item-class="budget-form_tabs_active_tab"
            nav-class="budget-form_tabs" 
            v-model="activeTabIndex"
        >

            <b-tab 
                :title="getCommonText('budget_expense')"
                @click="updateRoute(0)" 
            >
                <!-- Первая вклапдка -->
                <form-418-tab1  
                    ref="formTab"
                    :budgetForm="budgetForm"
                    :getFormText="getFormText"
                    :tableFields="tableFields"
                    :getCommonText="getCommonText"
                    :getDecText="getDecText"
                    :getUnitLockName="getUnitLockName"
                    :lng="lng"
                    :variantAttribute="variantAttribute"
                    :nameIsEmpty="nameIsEmpty"
                    :listUnit="listUnit"
                    :total="total"
                    :isLoad="isLoad"
                    @setSelectAll="setSelectAll"
                    @deleteItemWithAttachedFiles="deleteItemWithAttachedFiles"
                    @onEditCatName="onEditCatName"
                    @keyup13="keyup13"
                    @keyPress="keyPress"
                    @inputFixed="inputFixed"
                    @onFilesClick="onFilesClick"
                    @onAddNewCat="onEnterCategoryName"
                ></form-418-tab1>
        
                <!-- Первая вклапдка -->
                <files-updown v-if="isFilterReady" 
                            :header="header"
                            :variant-attribute="variantAttribute"
                            :variant-name="variantName ? variantName['pure_name_' + lng] : ''"
                            :load="load"
                            @getFiles="getFiles"
                            @getNewFiles="getNewFiles($event)"
                            @delFile="delFile($event)"
                            @onFilePreview="onFilePreview"
                            ref="fileUpdown"
                ></files-updown>

                <!-- Первая вклапдка -->
                <modal-files-management-nodecode
                    ref="modalFilesManagement"
                    :variant-attribute="variantAttribute"
                    @triggDownloadFile="triggDownloadFile"
                    @triggDownloadAllFiles="triggDownloadAllFiles"
                    @fileUpload="fileUpload"
                    @toggleIsAdd="toggleIsAdd($event)"
                />

                <!-- Первая вклапдка -->
                <c-set-b-f-category-name
                    ref="setCatNameModal"
                    :budgetForm="budgetForm"
                    :categoryFieldNames="categoryFieldNames"
                    :lng="lng"
                    :getCommonText="getCommonText"
                    @addItem="addItem"
                />
            </b-tab>
            <b-tab 
                :title="getCommonText('paid_services')" 
                @click="updateRoute(1)"
            >
                <!-- Вторая вклапдка -->
                <form-418-tab1  
                    ref="formTabPaid"
                    :budgetForm="budgetFormPaid"
                    :getFormText="getFormText"
                    :tableFields="tableFields"
                    :getCommonText="getCommonText"
                    :getDecText="getDecText"
                    :getUnitLockName="getUnitLockName"
                    :lng="lng"
                    :variantAttribute="variantAttribute"
                    :nameIsEmpty="nameIsEmpty"
                    :listUnit="listUnit"
                    :total="totalPaid"
                    :isLoad="isLoad"
                    @setSelectAll="setSelectAll"
                    @deleteItemWithAttachedFiles="deleteItemWithAttachedFilesPaid"
                    @onEditCatName="onEditCatNamePaid"
                    @selectedUnitChanged="selectedUnitChanged"
                    @keyup13="keyup13"
                    @keyPress="keyPress"
                    @inputFixed="inputFixed"
                    @onFilesClick="onFilesClickPaid"
                    @onAddNewCat="onEnterCategoryName"
                ></form-418-tab1>

                <!-- Вторая вклапдка -->
                <files-updown v-if="isFilterReady" 
                            :header="header"
                            :variant-attribute="variantAttribute"
                            :variant-name="variantName ? variantName['pure_name_' + lng] : ''"
                            :load="load"
                            :isPaidTab="true"
                            @getFiles="getFilesPaid"
                            @getNewFiles="getNewFilesPaid($event)"
                            @delFile="delFilePaid($event)"
                            @onFilePreview="onFilePreview"
                            ref="fileUpdownPaid"
                ></files-updown>

                <!-- Вторая вклапдка -->
                <modal-files-management-nodecode
                    ref="modalFilesManagementPaid"
                    :variant-attribute="variantAttribute"
                    @triggDownloadFile="triggDownloadFilePaid"
                    @triggDownloadAllFiles="triggDownloadAllFilesPaid"
                    @fileUpload="fileUploadPaid"
                    @toggleIsAdd="toggleIsAddPaid($event)"
                />

                <!-- Вторая вклапдка -->
                <c-set-b-f-category-name
                    ref="setCatNameModalPaid"
                    :budgetForm="budgetFormPaid"
                    :categoryFieldNames="categoryFieldNames"
                    :lng="lng"
                    :getCommonText="getCommonText"
                    @addItem="addItem"
                />
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import FilesUpdown from '@/modules/budget-request/FilesUpdown';
import BudgetFormsList from '@/modules/budget-request/components/budget-forms-list.vue';
import ModalFilesManagementNodecode from '@/modules/budget-request/components/modal-files-management-nodecode.vue';
import FormsHandlerMixin1Paid from "../mixins/forms-handler-mixin-1-paid";
import CBudgetFormsCopyData from '../components/budget-forms-copy-data.vue';
import FormsDownloadReprt from "../components/forms-download-reprt.vue";
import CSetBFCategoryName from "../components/c-set-bf-category-name.vue";
import Form418Tab1 from './Form418_tab1.vue';
import CBudgetFormsDataTransfer from '../components/budget-forms-data-transfer.vue';

export default {
    name: 'Form418',
    components: { 
        FilesUpdown, 
        BudgetFormsList, 
        FormsDownloadReprt, 
        ModalFilesManagementNodecode, 
        CBudgetFormsCopyData,
        CSetBFCategoryName,
        Form418Tab1,
        CBudgetFormsDataTransfer
    },
    mixins: [FormsHandlerMixin1Paid],
    data() {
        return {
            defaultParams: {
                gr: 5,
                abp: 253,
                prg: 33,
                ppr: 46
            },
            form: {
                code: '418',
                name_ru: 'Расчет расходов на материально-техническое оснащение государственных предприятий',
                name_kk: 'Мемлекеттік кәсіпорындарды материалдық-техникалық жабдықтарға шығындарды есептеу',
                spf: {
                    name: '418-Материально-техническое оснащение государственных предприятий',
                    spf: '418'
                }
            },
            dataTypeFilter: null,
            variantAttribute: null,
            variantName: null,
            budgetForm: [],
            budgetFormPaid: [],
            header: null,
            files: null,
            load: false,
            openDisabled: false,
            isLoad: false,
            row_files: [],
            isAdd: false,
            rowId: false,
            rowIdPaid: false,
            newRowStartId: -1,
            categoryFieldNames: {ru: "name_ru", kk: "name_kk"}
        };
    },
    async mounted() {
        await this.loadUnits();
    },
    created() {
        this.$emit("setForm", this.form);
    },
    watch: {
        openDisabled() {
            this.$emit("setOpenDisabled", this.openDisabled);
        },

        progress() {
            this.$emit("setProgress", this.progress);
        },

        selectAllPaid() {
            this.$refs.formTabPaid.setSelectAll(this.selectAllPaid);
        },

        selectAll() {
            this.$refs.formTab.setSelectAll(this.selectAll);
        }
    },

    methods: {
        addItem(nameRu, nameKk) {
            const item = { 
                id: this.newRowStartId,
                name_ru: nameRu,
                name_kk: nameKk
            };
            this.newRowStartId--;
            this.itemUpdate(item);
            this.defineCalcProps(item);
            if (this.activeTabIndex === 0) this.budgetForm.push(item);
            if (this.activeTabIndex === 1) this.budgetFormPaid.push(item);
        },

        defineCalcProps(item) {
            Object.defineProperty(item, 'total', {
                get: () => {
                    const amount = this.safeDecimal(item.amount);
                    const cost = this.safeDecimal(item.cost);
                    const totalRounded = amount.mul(cost).div(1000).toDecimalPlaces(2).toNumber();
                    return totalRounded;
                }
            });
        },

        async itemUpdate(item) {
            this.$set(item, 'unit', null);
            this.$set(item, 'unit_inf', null);
            this.$set(item, 'amount', 0);
            this.$set(item, 'cost', 0);
            this.$set(item, 'files', 0);
            this.$set(item, 'itemToDelete', false);

            try {
                this.load = true;
                let url = `/api-py/get-new-row-files-form/${item.id}`;
                if (this.activeTabIndex === 1) url = `/api-py/get-new-row-files-form-paid/${item.id}`;
                const response = await fetch(`${url}/${JSON.stringify(this.header)}`);
                const emptyRowFiles = await response.json();
                this.$set(item, 'row_files', emptyRowFiles);
            } catch (error) {
                this.makeToast('danger', `${this.getErrText('bad_request')} itemUpdate`, error.toString());
            }
            this.load = false;
        },

        number(value) {
            return (isNaN(parseFloat(value)) ? 0 : parseFloat(value));
        },

        getFiles(data) {
            this.files = data;
        },
        getFilesPaid(data) {
            this.filesPaid = data;
        },

        async loadDatas() {
            this.load = true;
            await this.budgetForm.splice(0);
            try {
                const response = await fetch('/api-py/get-budget-request-form-with-row-attach-files/' + JSON.stringify(this.header));
                const values = await response.json();
                this.fillBudgetForm(values, this.budgetForm);
            } catch (error) {
                this.makeToast('danger', `${this.getErrText('bad_request')} loadDatas`, error.toString());
            }
            this.load = false;
        },

        async loadDatasPaid() {
            this.load = true;
            await this.budgetFormPaid.splice(0);
            try {
                const response = await fetch('/api-py/get-budget-request-form-with-row-attach-files-paid/' + JSON.stringify(this.header));
                const values = await response.json();
                this.fillBudgetForm(values, this.budgetFormPaid);
            } catch (error) {
                this.makeToast('danger', `${this.getErrText('bad_request')} loadDatasPaid`, error.toString());
            }
            this.load = false;
        },


        fillBudgetForm(values, budgetForm) {
            values.forEach(val => {
                const item = {
                    id: val.id,
                    name_ru: val.name_ru,
                    name_kk: val.name_kk,
                    unit: val.unit,
                    unit_inf: this.getItem(val.unit, this.listUnit),
                    amount: val.amount,
                    files: val.files,
                    row_files: val.row_files,
                    cost: val.cost,
                    itemToDelete: false,
                };

                this.defineCalcProps(item);
                budgetForm.push(item);
            });
        },

        prepareForSave() {
            let budgetForm = [];
            if (this.activeTabIndex === 1) budgetForm = this.budgetFormPaid
            else budgetForm = this.budgetForm;
            const values = [];
            for (const row of budgetForm) {
                if (this.isSavingForbidden(row, this.tableFields, ['amount', 'cost'], [])) return;
                const item = Object.assign({}, this.header);
                this.$set(item, 'id', row.id);
                this.$set(item, 'name_ru', row.name_ru);
                this.$set(item, 'name_kk', row.name_kk);
                if (row.unit_inf) {
                    this.$set(item, 'unit', row.unit_inf.code);
                }
                else {
                    this.$set(item, 'unit', null);
                }
                this.$set(item, 'amount', parseInt(row.amount));
                this.$set(item, 'cost', parseFloat(row.cost));
                this.$set(item, 'row_files', row.row_files);

                values.push(item);
            }
            if (values.length > 0) {
                this.$bvModal.msgBoxConfirm(
                    this.getCommonText('on_save'),
                    {
                        title: this.getCommonText('confirm'),
                        size: 'lg',
                        buttonSize: 'sm',
                        okVariant: 'success',
                        okTitle: this.getCommonText('yes'),
                        cancelTitle: this.getCommonText('cancel'),
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                    })
                    .then(value => {
                        if (value && this.variantAttribute) {
                            if (this.activeTabIndex === 0) {
                                this.save(values);
                            } else { 
                                this.savePaid(values);
                            }
                        }
                    })
                    .catch(error => {
                        this.makeToast('danger', this.getErrText('saving_error'), error.toString());
                    });
            }
        },

        async save(values) {
            this.isLoad = true;
            try {
                this.$set(this.header, 'value', this.total);
                const url = this.header.mode === 'gkkp' ? '/api-py/save-brform-gkkp/' : '/api-py/save-brform' + this.form.code + '/'
                const response = await fetch(url + JSON.stringify(this.header), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(values)
                });
                const result = await response.json();
                if ((response.status === 200) && (result.result === 'success')) {
                    if (this.files.length === 0) {
                        this.makeToast('warning', this.getErrText('warning'), this.getErrText('no_docs'));
                    }
                    this.makeToast('success', this.getErrText('msg'), this.getErrText('saved'));
                    this.deletingAgreementTotalResultHandler(result);
                    await this.loadDatas();
                } else {
                    await this.loadDatas();
                    throw this.getErrText('bad_data');
                }
            } catch (e) {
                this.makeToast('danger', this.getErrText('warning'), e.toString());
            } finally {
                this.isLoad = false;
            }
        }, // сохранение данных

        async savePaid(values) {
            this.isLoad = true;
            try {
                this.$set(this.header, 'value', this.totalPaid);
                const url = '/api-py/save-brform-gkkp-paid/';
                const response = await fetch(url + JSON.stringify(this.header), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(values)
                });
                const result = await response.json();
                if ((response.status === 200) && (result.result === 'success')) {
                    if (this.filesPaid.length === 0) {
                        this.makeToast('danger', this.getErrText('warning'), this.getErrText('no_docs'));
                    }
                    this.makeToast('success', this.getErrText('msg'), this.getErrText('saved'));
                    await this.loadDatasPaid();
                } else {
                    await this.loadDatasPaid();
                    throw this.getErrText('bad_data');
                }
            } catch (e) {
                this.makeToast('danger', this.getErrText('warning'), e.toString());
            } finally {
                this.isLoad = false;
            }
        }, // сохранение данных
    },
    computed: {
        total() {
            let sum =this.safeDecimal(0);
            for (const row of this.budgetForm) {
                const total = this.safeDecimal(row.total);
                sum = sum.add(total);
            }
            return Math.ceil(sum.toNumber());
        },
        totalPaid() {
            let sum =this.safeDecimal(0);
            for (const row of this.budgetFormPaid) {
                const total = this.safeDecimal(row.total);
                sum = sum.add(total);
            }
            return Math.ceil(sum.toNumber());
        },
        getFormText() {
            return this.setFormText('form_4xx.');
        },

        tableFields() {
            if (this.$i18n.locale) {
                return [
                    {
                        key: 'action',
                        label: ' '
                    },
                    {
                        key: 'name',
                        label: this.getCommonText('name')
                    },
                    {
                        key: 'unit',
                        label: this.getUnitsText('measure')
                    },
                    {
                        key: 'amount',
                        label: this.getCommonText('count')
                    },
                    {
                        key: 'cost',
                        label: this.getFormText('expense_per_unit')
                    },
                    {
                        key: 'total',
                        label: this.getFormText('total_cost')
                    },
                    {
                        key: 'files',
                        label: this.getCommonText('files')
                    },
                    {
                        key: 'more',
                        label: ''
                    }
                ];
            }
            return [];
        },
    }
};
</script>

<style scoped>
    .filter-actions-flex {
        display: flex;
    }
    .budget-form_tabs {
        display: none;
    }
</style>